import { Suspense, type PropsWithChildren } from 'react'

import { PageLayoutSkeleton } from '@/layouts/page'

import { DetalhesEmpreendimentoPageSkeleton } from './skeleton'

export const DetalhesEmpreendimentoPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <DetalhesEmpreendimentoPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
